<div class="absolute bg-gray-500 opacity-50 inset-0 z-20 cursor-pointer" (click)="onCancelCall()"></div>
<div
  class="flex flex-col w-full max-w-3xl inset-y-8 p-4 rounded-md absolute z-20 bg-white shadow-lg left-1/2 -translate-x-1/2 top-8 md:top-1/3 md:-translate-y-1/2">
  <div class="border-b border-gray-200">
    <h2 class="font-bold text-3xl py-3">{{ title }}</h2>
  </div>
  <div class="w-full h-full py-2 overflow-y-auto">
    <ng-content></ng-content>
  </div>
  <div class="border-t border-gray-200 pt-3 sm:flex sm:flex-row-reverse">
    <button (click)="onConfirmCall()" type="button"
            class="inline-flex w-full justify-center rounded-md bg-theme-primary-700 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-theme-primary-900 sm:ml-3 sm:w-auto">{{ confirmText }}
    </button>
    <button (click)="onCancelCall()" type="button"
            class="inline-flex w-full justify-center rounded-md bg-white hover:!bg-gray-200 px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 sm:mt-0 sm:w-auto">
      {{ cancelText }}
    </button>
  </div>
</div>
